var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      padding: 10
    },
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9006 0.599609C50.0604 0.599609 51.0006 1.53981 51.0006 2.69961V4.79961H55.2006C57.5202 4.79961 59.4006 6.68001 59.4006 8.99961V55.1996C59.4006 57.5192 57.5202 59.3996 55.2006 59.3996H4.80059C2.48099 59.3996 0.600586 57.5192 0.600586 55.1996V8.99961C0.600586 6.68001 2.48099 4.79961 4.80059 4.79961H9.00059V2.69961C9.00059 1.53981 9.94079 0.599609 11.1006 0.599609C12.2604 0.599609 13.2006 1.53981 13.2006 2.69961V4.79961H46.8006V2.69961C46.8006 1.53981 47.7408 0.599609 48.9006 0.599609ZM55.1998 21.5996H4.7998V55.1996H55.1998V21.5996ZM51.0006 42.5996V50.9996H42.6006V42.5996H51.0006ZM8.9998 8.99951H4.7998V17.3995H55.1998V8.99951H50.9998V11.0995C50.9998 12.2593 50.0596 13.1995 48.8998 13.1995C47.74 13.1995 46.7998 12.2593 46.7998 11.0995V8.99951H13.1998V11.0995C13.1998 12.2593 12.2596 13.1995 11.0998 13.1995C9.94001 13.1995 8.9998 12.2593 8.9998 11.0995V8.99951Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5d169239.svg";
export { ForwardRef as ReactComponent };